import { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Navbar } from "./components/navbar";

import { AboutUs } from "./pages/about-us";
import { Contact } from "./pages/contact";
import { Footer } from "./pages/footer";
import { Games } from "./pages/games";
import { Home } from "./pages/home";

// lesgo.v1cardeira
function App() {
  const [backgroundImage, setBackgroundImage] = useState(
    "url('/Texture_Background.png')"
  );

  const handleBackgroundChange = (slideIndex?: number) => {
    switch (slideIndex) {
      case 0:
        setBackgroundImage(
          "url('/ataxx_background.png') center center / cover no-repeat"
        );
        break;
      case 1:
        setBackgroundImage(
          "url('/TapFastWallpaper.png') center center / cover no-repeat"
        );
        break;
      case 2:
        setBackgroundImage(
          "url('/Site_WordSort/wordsortbg.png') center center / cover no-repeat"
        );
        break;
      case 3:
        setBackgroundImage("#FFF");
        break;
      default:
        setBackgroundImage(
          "url('/Texture_Background.png') center center / cover no-repeat"
        );
        break;
    }
  };

  return (
    <Router>
      <div className="relative w-screen h-screen">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            background: backgroundImage,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <Navbar handleBackgroundChange={handleBackgroundChange} />

        {/* Main Content Area */}
        <div className="flex flex-col items-center z-10 overflow-y-auto min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/games"
              element={
                <Games handleBackgroundChange={handleBackgroundChange} />
              }
            />
            <Route path="/portfolio" element={
              <Games handleBackgroundChange={handleBackgroundChange} />
            } />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
